import { useContext, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";

import { ImageContext } from "context";
import { IProps } from "../../types/types";
import IconFile from "../../assets/icons/file.svg";
import styles from "../../styles/FileField.module.scss";

export const FileField = ({ name, label, required, component }: IProps) => {
  const { filesContext, setFilesContext } = useContext(ImageContext);
  const [hasFile, setHasFile] = useState(false);
  const { register, trigger } = useFormContext();

  const fileName = useMemo(() => {
    if (!hasFile) return "";
    const _fileName: string = filesContext[name][0]["name"];
    return _fileName;
  }, [filesContext, name, hasFile]);

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files: FileList | any = event.target.files;
    setFilesContext({
      ...filesContext,
      [name]: files,
    });
    setHasFile(true);
  };

  return (
    <div className={styles.formItem}>
      <section style={{ marginBottom: "0.5rem" }}>
        <span>{label}</span>
      </section>
      <div className={styles.wrapper}>
        <div
          className={styles.containerFile}
          style={{ border: `1px solid #6b6b6b` }}
        >
          <label htmlFor={name}>
            <img src={IconFile} alt="Icon upload file" />
            Subir archivo
          </label>
          <input
            type={component.type}
            id={name}
            accept=".png,.jpg,.jpeg,.pdf"
            {...register(name, { required: required })}
            onKeyUp={() => {
              trigger(name);
            }}
            onChange={onFileChange}
          />
        </div>
        <span>{fileName}</span>
      </div>
    </div>
  );
};
